import * as SharedDocumentActions from "./sharedDocumentActions";

export default SharedDocumentActions;



// WEBPACK FOOTER //
// ./src/actions/SharedDocumentActions/index.js